//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './FeaturesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type FeaturesGetFeaturesQueryParameters = {
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type FeaturesUpdateFeaturesQueryParameters = {
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export type FeaturesDeleteFeaturesQueryParameters = {
  providerName?: string | undefined ;
  providerKey?: string | undefined ;
}

export function featuresGetUrl(providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/feature-management/features?";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let featuresGetDefaultOptions: Omit<UseQueryOptions<Types.GetFeatureListResultDto, unknown, Types.GetFeatureListResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.GetFeatureListResultDto, unknown, Types.GetFeatureListResultDto>, 'queryFn'>> = {
};
export function getFeaturesGetDefaultOptions() {
  return featuresGetDefaultOptions;
};
export function setFeaturesGetDefaultOptions(options: typeof featuresGetDefaultOptions) {
  featuresGetDefaultOptions = options;
}

export function featuresGetQueryKey(dto: FeaturesGetFeaturesQueryParameters): QueryKey;
export function featuresGetQueryKey(providerName?: string | undefined, providerKey?: string | undefined): QueryKey;
export function featuresGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { providerName, providerKey,  } = params[0] as FeaturesGetFeaturesQueryParameters;

    return trimArrayEnd([
        'FeaturesClient',
        'featuresGet',
        providerName as any,
        providerKey as any,
      ]);
  } else {
    return trimArrayEnd([
        'FeaturesClient',
        'featuresGet',
        ...params
      ]);
  }
}
export function __featuresGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.featuresGet(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useFeaturesGetQuery<TSelectData = Types.GetFeatureListResultDto, TError = unknown>(dto: FeaturesGetFeaturesQueryParameters, options?: Omit<UseQueryOptions<Types.GetFeatureListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function useFeaturesGetQuery<TSelectData = Types.GetFeatureListResultDto, TError = unknown>(providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseQueryOptions<Types.GetFeatureListResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useFeaturesGetQuery<TSelectData = Types.GetFeatureListResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.GetFeatureListResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let providerName: any = undefined;
  let providerKey: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ providerName, providerKey,  } = params[0] as FeaturesGetFeaturesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [providerName, providerKey, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.GetFeatureListResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __featuresGet(context, axiosConfig) : __featuresGet,
    queryKey: featuresGetQueryKey(providerName, providerKey),
    ...featuresGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.GetFeatureListResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setFeaturesGetData(queryClient: QueryClient, updater: (data: Types.GetFeatureListResultDto | undefined) => Types.GetFeatureListResultDto, providerName?: string | undefined, providerKey?: string | undefined) {
  queryClient.setQueryData(featuresGetQueryKey(providerName, providerKey),
    updater
  );
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function setFeaturesGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.GetFeatureListResultDto | undefined) => Types.GetFeatureListResultDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function featuresUpdateUrl(providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/feature-management/features?";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function featuresUpdateMutationKey(providerName?: string | undefined, providerKey?: string | undefined): MutationKey {
  return trimArrayEnd([
      'FeaturesClient',
      'featuresUpdate',
      providerName as any,
      providerKey as any,
    ]);
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function useFeaturesUpdateMutation<TContext>(providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateFeaturesDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateFeaturesDto, TContext> {
  const key = featuresUpdateMutationKey(providerName, providerKey);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.UpdateFeaturesDto) => Client.featuresUpdate(providerName, providerKey, body),
    mutationKey: key,
  });
}
  
type FeaturesUpdate__MutationParameters = FeaturesUpdateFeaturesQueryParameters & {
  body: Types.UpdateFeaturesDto;
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @param body (optional) 
 * @return OK
 */
export function useFeaturesUpdateMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, FeaturesUpdate__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: FeaturesUpdateFeaturesQueryParameters}): UseMutationResult<void, unknown, FeaturesUpdate__MutationParameters, TContext> {
  const key = featuresUpdateMutationKey(options?.parameters?.providerName!, options?.parameters?.providerKey!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: FeaturesUpdate__MutationParameters) => Client.featuresUpdate(data.providerName ?? options?.parameters?.providerName!, data.providerKey ?? options?.parameters?.providerKey!, data.body),
  mutationKey: key,
});
}
  
export function featuresDeleteUrl(providerName?: string | undefined, providerKey?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/feature-management/features?";
if (providerName === null)
    throw new Error("The parameter 'providerName' cannot be null.");
else if (providerName !== undefined)
    url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
if (providerKey === null)
    throw new Error("The parameter 'providerKey' cannot be null.");
else if (providerKey !== undefined)
    url_ += "providerKey=" + encodeURIComponent("" + providerKey) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function featuresDeleteMutationKey(providerName?: string | undefined, providerKey?: string | undefined): MutationKey {
  return trimArrayEnd([
      'FeaturesClient',
      'featuresDelete',
      providerName as any,
      providerKey as any,
    ]);
}

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function useFeaturesDeleteMutation<TContext>(providerName?: string | undefined, providerKey?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = featuresDeleteMutationKey(providerName, providerKey);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.featuresDelete(providerName, providerKey),
    mutationKey: key,
  });
}
  
type FeaturesDelete__MutationParameters = FeaturesDeleteFeaturesQueryParameters

/**
 * @param providerName (optional) 
 * @param providerKey (optional) 
 * @return OK
 */
export function useFeaturesDeleteMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, FeaturesDelete__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: FeaturesDeleteFeaturesQueryParameters}): UseMutationResult<void, unknown, FeaturesDelete__MutationParameters, TContext> {
  const key = featuresDeleteMutationKey(options?.parameters?.providerName!, options?.parameters?.providerKey!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: FeaturesDelete__MutationParameters) => Client.featuresDelete(data.providerName ?? options?.parameters?.providerName!, data.providerKey ?? options?.parameters?.providerKey!),
  mutationKey: key,
});
}